module.exports = __webpack_public_path__ + "assets/path-4-098b8adaaa4669088dce9e941d52a2ad.svg";